// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateWorkspace_createButton__1cHOw","buttonContainer":"CreateWorkspace_buttonContainer__3dQuk","button":"CreateWorkspace_button__ZyBBR"};